const styles = {
  container: 'w-full bg-primary-600 z-20  text-sm py-3',
  content:
    'flex flex-row items-center gap-x-1 group hover:cursor-pointer !text-xs sm:text-sm',
};

export default styles;
